import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "question-label-container"
};
const _hoisted_2 = {
  key: 0,
  class: "label"
};
const _hoisted_3 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.label?.length ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.label), 1)) : _createCommentVNode("", true), _ctx.labelDetail?.length ? (_openBlock(), _createElementBlock("p", {
    key: 1,
    class: "label-detail",
    innerHTML: _ctx.labelDetail
  }, null, 8, _hoisted_3)) : _createCommentVNode("", true)]);
}